import { FormEvent, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import userStore from 'entities/user/module/user-store'

import { UserApi } from 'shared/api/UserApi.ts'
import { EMAIL_REGEX, REGEX_EMAIL } from 'shared/constants/regex'
import ErrorImage from 'shared/images/error.png'
import SuccessImage from 'shared/images/success_popup.png'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Input } from 'shared/ui/input'
import { PopupContent } from 'shared/ui/poup-content'

import styles from './styles.module.scss'

enum RESULT_SAVE {
  SUCCESS = 'success',
  ERROR = 'error',
}

const DetailProfile = observer(() => {
  const { t } = useTranslation()

  const { closeDialog, openDialog } = useDialogBottomSheet()

  const accountData = userStore.account

  const [email, setEmail] = useState<string>(accountData?.email || '')

  // const optionsGender = [
  //   { name: GENDER.MALE, option: t('male') },
  //   { name: GENDER.FEMALE, option: t('female') },
  // ]

  const onChangeInputEmail = (event: FormEvent<HTMLInputElement>) => {
    const value = event?.currentTarget?.value?.replace(REGEX_EMAIL, '')

    setEmail(value)
  }

  const onSaveEmail = async () => {
    if (!EMAIL_REGEX.test(email)) {
      return
    }

    try {
      await UserApi.updateEmail(email)

      userStore.saveEmail(email)

      showPopUp(RESULT_SAVE.SUCCESS)
    } catch (e) {
      showPopUp(RESULT_SAVE.ERROR)
    }
  }

  const showPopUp = (type: RESULT_SAVE) => {
    const resultText = {
      [RESULT_SAVE.ERROR]: {
        button: t('got'),
        title: t('error'),
        image: ErrorImage,
        description: t('error_des'),
      },
      [RESULT_SAVE.SUCCESS]: {
        image: SuccessImage,
        button: t('got'),
        title: t('change_email.title'),
        description: t('change_email.sub_title'),
      },
    }

    openDialog({
      child: (
        <PopupContent
          onClick={closeDialog}
          {...resultText[type]}
        />
      ),
      isDialog: false,
    })
  }

  const isChanged = String(email) !== String(accountData?.email)

  // const itemDetail = [
  //   {
  //     title: t('citizenship'),
  //     content: (accountData?.citizenship || '').toUpperCase(),
  //   },
  //   {
  //     title: t('serial_documents'),
  //     content: String(accountData?.id_card_number),
  //   },
  //   {
  //     title: t('expiration_date'),
  //     content: showWrongDateFormat(
  //       accountData?.id_card_expire || '',
  //       DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
  //     ),
  //   },
  //   {
  //     title: t('last_name'),
  //     content: accountData?.last_name,
  //   },
  //   {
  //     title: t('first_name'),
  //     content: accountData?.first_name,
  //   },
  //   // {
  //   //   title: t('middle_name'),
  //   //   content: accountData?.middle_name,
  //   // },
  //   {
  //     title: t('gender'),
  //     content: optionsGender?.filter(
  //       (gender) => gender.name === accountData?.gender,
  //     )[0]?.option,
  //   },
  //   {
  //     title: t('birth_day'),
  //     content:
  //       showWrongDateFormat(
  //         accountData?.date_of_birth || '',
  //         DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
  //       ) || t('empty'),
  //   },
  // ]

  const resultValidate = !EMAIL_REGEX.test(email)

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeaderGoBack
          title={t('email')}
          variant="grey"
          buttonWhite
        />
      </div>

      <div className={styles.itemForm}>
        <Input
          value={email}
          error={resultValidate}
          placeholder={t('email')}
          onChange={onChangeInputEmail}
        />
      </div>

      {/* <Paper padding={[8, 16]}>
        <div className={styles.itemDetails}>
          {itemDetail.map((item) => (
            <div className={styles.itemDetailsContent}>
              <span>{item.title}</span>
              <p>{item.content?.toString()}</p>
            </div>
          ))}
        </div>
      </Paper> */}

      <ButtonContinue
        disabled={!isChanged}
        onClick={onSaveEmail}
      >
        <span className={styles.text}>{t('save')}</span>
      </ButtonContinue>
    </div>
  )
})

export default DetailProfile
